<template>
  <div>
    <a
      v-if="index > 0"
      href="javascript:void(0)"
      @click="$emit('onMove', 'left')"
      style="margin-right: 10px"
      ><span class="fa fa-caret-left"></span
    ></a>
    <a v-if="index < lastIndex" href="javascript:void(0)" @click="$emit('onMove', 'right')"
      ><span class="fa fa-caret-right"></span
    ></a>
  </div>
</template>

<script>
export default {
  props: ['index', 'max'],
  computed: {
    lastIndex: function() {
      return this.max - 1
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/MoveHorizontal.vue